// src/pages/InstructionPage.jsx
import React from 'react';
import { motion } from 'framer-motion';
import Instruction from '../components/Instruction';

export default function InstructionPage() {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className="pt-8"
    >
      <Instruction />
    </motion.div>
  );
}